import http from './httpService';

const apiEndPoint = '/credits';

function creditUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getCredits() {
  return http.get(apiEndPoint);
}

export function getCredit(creditId) {
  return http.get(creditUrl(creditId));
}

export function saveCredit(credit) {
  if (credit._id) {
    const body = { ...credit };
    delete body._id;
    return http.put(creditUrl(credit._id), body);
  }

  return http.post(apiEndPoint, credit);
}

export function deleteCredit(creditId) {
  return http.delete(creditUrl(creditId));
}
